// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","titleContainer":"Header_titleContainer__AU+D+","titleText":"Header_titleText__IXbEM"};